import { type ReactNode } from 'react';
import { Platform, StyleSheet } from 'react-native';

import { Text, XStack, YStack } from '@fhs/ui';

import type { MoreLink } from './more-navigation';
import { MoreLinkCard } from './shared';

type MoreSectionProps = {
  title: string;
  icon: ReactNode;
  links: readonly MoreLink[];
};

export function MoreSection({ title, icon, links }: MoreSectionProps) {
  return (
    <YStack style={styles.section}>
      <XStack style={styles.heading}>
        {icon}
        <Text.Heading
          type="three"
          {...(Platform.OS === 'web' ? ({ role: 'heading', 'aria-level': 2 } as const) : {})}
        >
          {title}
        </Text.Heading>
      </XStack>
      <MoreLinkCard links={links} />
    </YStack>
  );
}

const styles = StyleSheet.create({
  section: { gap: 16 },
  heading: { alignItems: 'center', gap: 8 },
});
